import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Script from "react-load-script";
import {
	API_URL,
	FORTE_API,
	FORTE_SCRIPT,
	TURNSTILE_KEY,
	fmtCurrency,
	isCardType,
} from "../helpers";
import "./styles.css";
import Left from "./Left";
import Right from "./Right";
import CreditPayment from "./CreditPayment";
import BillPayment from "./BillPayment";
import Goals from "./Goals";
//import Suggested from "./Suggested";
//import Images from "./Images";
import Video from "./Video";
import Total from "./Total";
import Top10 from "./Top10";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Radios from "../components/Radios";
import Turnstile from "../components/Turnstile";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const FriendsDonate = () => {
	const [details, setDetails] = useState({
		amts: [],
		links: [],
		imgs: [],
		top10: [],
	});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		donateForm: false,
		copyLink: false,
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [turnstileToken, setTurnstileToken] = useState(null);

	const history = useHistory();
	const query = new URLSearchParams(useLocation().search);
	const formElement = useRef(null);
	const turnstileRef = useRef(null);

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/friendsDonateInit`);
		const params = {
			code: query.get("code") || "",
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handleUpdate("charityId", json.charityId);
				setDetails({ ...json });
				setAlert({});
			} else {
				history.push("/participating-charities");
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "copyLink") {
			const value = `https://valerotexasopen.com/championsforecharity/friends/donate?code=${query.get(
				"code",
			)}`;
			navigator.clipboard.writeText(value);
			setNames((names) => ({ ...names, [name]: true }));
		} else if (name === "donateForm") {
			setNames((names) => ({ ...names, [name]: true }));
		} else if (name === "amt" && value !== "other") {
			setNames((names) => ({
				...names,
				[name]: value,
				//donation: parseFloat(value),
			}));
		} else if (name === "other") {
			setNames((names) => ({
				...names,
				[name]: parseFloat(value.replace(/,/g, "")) * 100,
				//donation: parseFloat(value),
			}));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleDetails = (name, value) => {
		setDetails((details) => ({ ...details, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/donate`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "number" || key === "expdate" || key === "code") {
			} else {
				formData.append(key, value);
			}
		});
		formData.append("turnstileToken", turnstileToken);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				if (json.payment === "credit") {
					//handleUpdate("donation", json.donation);
					handlePayment(json.donation);
				} else {
					handleBill(json.donation);
				}
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
				turnstileRef.current.reset();
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
			turnstileRef.current.reset();
		}
	};

	const handlePayment = (donation) => {
		if (names.payment === "credit") {
			if (!names.number || !names.expdate || !names.code) {
				let array = [];
				if (!names.number) {
					array.push("number");
				}
				if (!names.expdate) {
					array.push("expdate");
				}
				if (!names.code) {
					array.push("code");
				}
				setErrors(array);
				setMsg({
					type: "error",
					text: "Please make an entry in all payment fields (*).",
				});
				return false;
			} else if (!isCardType(names.number || "")) {
				setMsg({
					type: "error",
					text: "Please enter a valid credit card number.",
				});
				return false;
			} else if (
				names.expdate.split("/").length !== 2 ||
				names.expdate.length < 6
			) {
				setMsg({
					type: "error",
					text: "Please check the format of your expiration date (mm/yyyy).",
				});
				return false;
			} else {
				const number = names.number.trim().replace(/\s/g, "").replace(/-/g, "");
				const array = names.expdate.trim().split("/");
				const month = array[0] || "";
				const year = array[1] || "";

				const data = {
					api_login_id: FORTE_API,
					card_number: number,
					expire_month: month,
					expire_year: year,
					cvv: names.code.trim() || "",
				};
				window.forte
					.createToken(data)
					.success(onTokenCreated.bind(null, donation))
					.error(onTokenFailed);
			}
		}
	};

	const handleScriptCreate = () => {
		handleUpdate("scriptLoaded", false);
	};

	const handleScriptError = () => {
		setMsg({
			type: "error",
			text: "An error occurred loading the payment gateway.",
		});
	};

	const handleScriptLoad = () => {
		handleUpdate("scriptLoaded", true);
	};

	const onTokenCreated = async (donation, response) => {
		const url = new URL(`${API_URL}/donateSubmit`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "number" || key === "expdate" || key === "code") {
			} else {
				data.append(key, value);
			}
		});
		data.append("donation", donation);
		data.append("ott", response.onetime_token);
		data.append("cardType", response.card_type);
		data.append("lastFour", response.last_4);
		data.append("friendsgivingId", details.friendId);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: "/receipt",
					state: {
						id: json.id,
						type: "donate",
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const onTokenFailed = (response) => {
		setMsg({
			type: "error",
			text: `Error. ${response.response_description}`,
		});
	};

	const handleBill = async (donation) => {
		const url = new URL(`${API_URL}/donateSubmit`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (
				key === "number" ||
				key === "expdate" ||
				key === "code" ||
				key === "donation"
			) {
			} else {
				data.append(key, value);
			}
		});
		data.append("donation", donation);
		data.append("friendsgivingId", details.friendId);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: "/receipt",
					state: {
						id: json.id,
						type: "donate",
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column" style={{ minHeight: "100%" }}>
			<Hdg section="Donations" />
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div className="donate-charity-box">
						<div>
							<Left
								data={{
									friend: details.friend,
									charity: details.charity,
									mission: details.mission,
									open: details.open ? details.open : false,
									donateForm: names.donateForm,
									copyLink: names.copyLink,
									image: details.imgs[0],
								}}
								click={handleUpdate}
							/>
							<Right
								data={{
									logo: details.logo,
									charity: details.charity,
									links: details.links,
								}}
							/>
						</div>

						<Script
							url={FORTE_SCRIPT}
							onCreate={handleScriptCreate}
							onError={handleScriptError}
							onLoad={handleScriptLoad}
						/>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className={names.donateForm ? "" : "hidden"}
						>
							<h3 style={{ marginTop: "0" }}>Donation Amount</h3>
							<p>100% of your donation will benefit {details.charity}.</p>

							<div className="amount-grid">
								{details.amts.map((item, index) => {
									return (
										<button
											key={index}
											type="button"
											className={
												item.amt === names.amt
													? "btn btn-primary"
													: "btn btn-default"
											}
											onClick={(e) => {
												handleUpdate("amt", item.amt);
												handleDetails("description", item.description);
											}}
										>
											{item.name}
										</button>
									);
								})}
							</div>

							{names.amt === "other" && (
								<div className="form-group one">
									<Input
										name="other"
										label="Enter Donation Amount"
										reqd={true}
										value={names.other || ""}
										update={handleUpdate}
										errors={errors}
										addonIcon="fa-dollar-sign"
										note="Minimum donation is $5"
									/>
								</div>
							)}

							{details.description && (
								<p
									style={{
										marginTop: "0",
										fontWeight: "bold",
										fontSize: "1.05rem",
										lineHeight: "20px",
									}}
								>
									{`A ${fmtCurrency(names.amt / 100)} donation ${
										details.description
									}`}
								</p>
							)}

							<h3 style={{ marginTop: "20px" }}>Donor Details</h3>

							<div className="form-group">
								<Input
									name="company"
									label="Company Name"
									reqd={false}
									value={names.company || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="fname"
									label="First Name"
									reqd={false}
									value={names.fname || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="given-name"
								/>
								<Input
									name="lname"
									label="Last Name"
									reqd={false}
									value={names.lname || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="family-name"
								/>
							</div>

							<div className="form-group">
								<Input
									name="email"
									label="Email"
									reqd={true}
									value={names.email || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="phone"
									label="Phone"
									reqd={true}
									value={names.phone || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="tel"
								/>
							</div>

							<div className="form-group">
								<Input
									name="address"
									label="Address"
									reqd={true}
									value={names.address || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="street-address"
								/>
								<Input
									name="address2"
									label="Address 2"
									reqd={false}
									value={names.address2 || ""}
									update={handleUpdate}
									errors={errors}
								/>
							</div>
							<div className="form-group three">
								<Input
									name="city"
									label="City"
									reqd={true}
									value={names.city || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="address-level2"
								/>
								<Input
									name="st"
									label="State (2-letter)"
									reqd={true}
									value={names.st || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="address-level1"
								/>
								<Input
									name="zip"
									label="Zip Code"
									reqd={true}
									value={names.zip || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="postal-code"
								/>
							</div>

							<div className="form-group">
								<Input
									name="reference"
									label={details.reflabel || "Reference (Optional)"}
									reqd={false}
									value={names.reference || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>

							<div className="form-group radios">
								<Radios
									label="How would you like to be recognized on the Top 10 leaderboard?"
									reqd={true}
									data={[
										{
											name: "attribute",
											val: "company",
											label: names.company
												? `Company Name (${names.company})`
												: `Company Name`,
										},
										{
											name: "attribute",
											val: "name",
											label:
												names.fname && names.lname
													? `First Initial Last Name (${names.fname.charAt(
															0,
													  )}. ${names.lname})`
													: `First Initial Last Name`,
										},

										{
											name: "attribute",
											val: "anonymous",
											label: "Anonymous",
										},
									]}
									value={names.attribute || ""}
									click={handleUpdate}
								/>
							</div>

							<h3>Payment</h3>

							<div className="form-group radios">
								<Radios
									label="Please select your payment method:"
									reqd={true}
									data={[
										{
											name: "payment",
											val: "credit",
											label: "Credit or Debit Card",
										},
										{
											name: "payment",
											val: "bill",
											label: "Bill Me",
										},
									]}
									value={names.payment || ""}
									click={handleUpdate}
								/>
							</div>

							{names.payment === "credit" && (
								<CreditPayment
									update={handleUpdate}
									data={{
										number: names.number || "",
										expdate: names.expdate || "",
										code: names.code || "",
										amt:
											names.amt === "other" && names.other > 0
												? names.other
												: names.amt
												? names.amt
												: 0,
										charity: details.charity,
									}}
									errors={errors}
								/>
							)}

							{names.payment === "bill" && (
								<BillPayment
									update={handleUpdate}
									data={{
										amt: names.amt || 0,
										charity: details.charity,
									}}
								/>
							)}

							<div
								style={{
									marginTop: "25px",
									paddingBottom: "10px",
								}}
							>
								<Turnstile
									ref={turnstileRef}
									siteKey={TURNSTILE_KEY}
									onVerify={function (value) {
										setTurnstileToken(value);
									}}
									onExpire={function () {
										setTurnstileToken("");
									}}
									onError={function () {
										setTurnstileToken("");
										console.error("Turnstile error");
									}}
								/>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										submit={
											names.payment === "credit"
												? "Submit Donation & Payment"
												: "Submit Donation"
										}
									/>
								</div>
							</div>
						</form>
					</div>

					<div className="charity-box-grid">
						<div style={{ paddingTop: "0" }}>
							<Goals
								data={{
									friendFname: details.friendFname,
									friendText: details.friendText,
									percent: details.percent,
									number: details.number,
									remainder: details.remainder,
									pledged: details.pledged,
									goal: details.goal,
								}}
							/>
							{/*details.amts.length > 0 && <Suggested data={details.amts} />*/}
							{/*{details.imgs.length > 0 && <Images data={details.imgs} />} */}
							{details.video.youtubeId && <Video data={details.video} />}
						</div>
						<div>
							<Total
								data={{
									total: details.total,
									fname: details.friendFname,
									charity: details.charity,
								}}
							/>
							{details.top10.length > 0 && <Top10 data={details.top10} />}
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default FriendsDonate;
